import mod from "-!./Paging.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Paging.js?vue&type=script&lang=js&"